import { createContext, useContext, useState, useEffect } from 'react';

const DEFAULT_SETTINGS = {
  fontSize: 'normal',
  contrast: 'default',
  images: true,
};

const AccessibilityContext = createContext();

export const AccessibilityProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem('accessibilitySettings');
    return saved ? JSON.parse(saved) : DEFAULT_SETTINGS;
  });

  // Save to localStorage when settings change
  useEffect(() => {
    localStorage.setItem('accessibilitySettings', JSON.stringify(settings));
  }, [settings]);

  // Apply CSS variables globally
  useEffect(() => {
    const root = document.documentElement;

    // Font size
    const fontSizeMap = {
      default: '1rem',
      large: '1.1rem',
      xlarge: '1.2rem',
    };
    root.style.setProperty('--font-size', fontSizeMap[settings.fontSize]);

    // Contrast
    // Контрастность
    if (settings.contrast === 'dark') {
      root.style.setProperty('--bg-primary', '#000000');
      root.style.setProperty('--text-primary', '#ffffff');
    } else if (settings.contrast === 'light') {
      root.style.setProperty('--bg-primary', '#ffffff');
      root.style.setProperty('--text-primary', '#000000');
    } else {
      root.style.setProperty('--bg-primary', '');
      root.style.setProperty('--text-primary', '');
    }

    document.querySelectorAll('img:not(.keep-image)').forEach(img => {
      img.style.display = settings.images ? '' : 'none';
      img.setAttribute('aria-hidden', !settings.images);
    })
  }, [settings]);

  return (
    <AccessibilityContext.Provider value={{ settings, setSettings }}>
      {children}
    </AccessibilityContext.Provider>
  );
};

export const useAccessibility = () => useContext(AccessibilityContext)